import ApiClient from '../apiClient'
import { getUserId } from '../user'
import { DEFAULT_PAGE_SIZE } from '../../config'

const client = new ApiClient()

const getCorporateTaxes = ({
  userId = getUserId(),
  page = 1,
  per_page = DEFAULT_PAGE_SIZE,
}) => {
  return client.get(`/users/${userId}/corporate-taxes`, {
    params: { page, per_page },
  })
}

const corporateTaxService = {
  getCorporateTaxes,
}

export default corporateTaxService
